import React, { FC } from 'react';
import { FormSelectProps } from './types';
import { WithStyle } from '@ch/common/utils';
import { FormSelectStyled } from './select.styled';
import { CustomField } from 'react-uforms';
import {
  DropdownIndicator,
  ClearIndicator,
  NoOptionsMessage,
  MultiValueRemove,
  OptionMultiple,
} from './select-elements';
import { OptionTypeBase } from 'react-select';
import { formatDefaultValues } from './select';

export const FormSelectCreatable: FC<FormSelectProps> & WithStyle = props => {
  const defaultCreateMessage = (inputValue: string) => `Create ${inputValue}`;
  const {
    name,
    hideError,
    disabled,
    required,
    options,
    onChange,
    instanceId,
    placeholder,
    optionIcon,
    onBlur,
    isMulti,
    isClearable,
    menuPlacement,
    createMessage = defaultCreateMessage,
  } = props;
  const Option = OptionMultiple;

  const validateNewOption = (inputValue: string, selectValue: string, selectOptions: OptionTypeBase[]) => {
    const exactValueExists = selectOptions.find(option => option.value === inputValue);
    const valueIsNotEmpty = inputValue.trim().length;
    return !exactValueExists && valueIsNotEmpty;
  };
  return (
    <CustomField {...{ name }} hideError={hideError}>
      {({ getValue, setValue, setTouched, getErrors }) => {
        const defaultValue = getValue() ? formatDefaultValues(getValue(), options) : undefined;
        return (
          <FormSelectStyled
            defaultValue={defaultValue}
            formatCreateLabel={createMessage}
            components={{ DropdownIndicator, ClearIndicator, NoOptionsMessage, Option, MultiValueRemove }}
            isCreatable={true}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            isDisabled={disabled}
            value={getValue() ? formatDefaultValues(getValue(), options) : null}
            className="react-select-container"
            classNamePrefix="react-select-creatable"
            onChange={(newValue: any, action: any) => {
              let value = undefined;
              if (newValue) {
                value = Array.isArray(newValue) ? newValue.map(item => item.value) : newValue.value;
              }
              setValue(value, () => {
                if (onChange) {
                  onChange(newValue, action);
                }
              });
            }}
            onBlur={(event: any) => {
              if (onBlur) {
                onBlur(event);
              }
              setTouched();
            }}
            instanceId={instanceId || name}
            isValidNewOption={validateNewOption}
            error={Array.isArray(getErrors()) && getErrors().length > 0}
            {...{ menuPlacement, name, required, options, placeholder, optionIcon, isMulti, isClearable }}
          />
        );
      }}
    </CustomField>
  );
};

FormSelectCreatable.defaultProps = {
  IsMulti: false,
  menuPlacement: 'auto',
  hideError: false,
};

FormSelectCreatable.displayName = 'FormSelectCreatable';
